export const SILENT_RENEW_PAGE_NS = 'pages/SilentRenewPage';

export const i18n = {
  en: {
    refreshing: 'Refreshing session....{{ path }}',
  },
};
